import type { Operand } from 'api/schemas/operand';
import type { I18nLanguage, I18nScopedKey, I18nTranslateFunction } from 'i18n';

import { formatInstructionOperand } from '../formatInstructionOperand/formatInstructionOperand';

type FormatOperandsListOptions = {
  language?: I18nLanguage;
  t?: I18nTranslateFunction<I18nScopedKey<'features'>>;
};

export const formatOperandsList = (operands: Operand[], options?: FormatOperandsListOptions): string => {
  const formattedOperands = operands.map((operand) => formatInstructionOperand(operand, options?.t));

  if (formattedOperands.length === 0) {
    return '';
  }

  if (formattedOperands.length === 1) {
    return formattedOperands[0];
  }

  if (options?.language) {
    return new Intl.ListFormat(options.language, { style: 'long', type: 'conjunction' }).format(formattedOperands);
  }

  return formattedOperands.join(', ');
};
